/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';
import { investmentDetailsGetResponseSchema } from './investmentDetailsGetResponseSchema.ts';

/**
 * @description 200 response
 */
export const getInvestmentDetails200Schema = z.lazy(() => investmentDetailsGetResponseSchema);

/**
 * @description 505 response
 */
export const getInvestmentDetails505Schema = z.any();

export const getInvestmentDetailsQueryResponseSchema = z.lazy(() => getInvestmentDetails200Schema);
